/*
 * Public API Surface of evk-expedientes
 */

export * from './lib/expediente/expediente.module';

export * from './lib/expediente/services/wizard-expedientes.service';
export * from './lib/expediente/componentes/expedientes-wizard/expedientes-wizard.component';
export * from './lib/expediente/componentes/expedientes-page/expedientes-page.component';
export * from './lib/expediente/componentes/expedientes-create/expedientes-create.component';

export * from './lib/expediente/componentes/prestacion-social-page/prestacion-social-page.component';
export * from './lib/expediente/componentes/sub-components/upload-file-expediente/uploap-file-expediente.component';
export * from './lib/expediente/componentes/sub-components/upload-file-expediente/upload-file-expediente.service';
export * from './lib/expediente/componentes/sub-components/detalle-prestacion/detalle-prestacion.component';
export * from './lib/expediente/componentes//sub-components/detalle-prestacion/datos-entrega/datos-entrega.component';
export * from './lib/expediente/componentes//sub-components/detalle-prestacion/datos-beneficiario/datos-beneficiario.component';
export * from './lib/expediente/componentes//sub-components/detalle-prestacion/datos-georeferencia/datos-georeferencia.component';
export * from './lib/expediente/componentes//sub-components/detalle-prestacion/datos-programa/datos-programa.component';
export * from './lib/expediente/componentes//sub-components/detalle-prestacion/datos-localizacion/datos-localizacion.component';
export * from './lib/expediente/componentes/sub-components/actualizacion-dialog/actualizacion-dialog.component';

export * from './lib/wizard/wizard.module';
export * from './lib/wizard/componentes/principal/wizard.component';
export * from './lib/wizard/interface/wizard-informacion.types';
export * from './lib/wizard/componentes/simple-section/simple-section.component';
export * from './lib/wizard/componentes/section/sub-components/evk-mapas/evk-mapas.component';

export * from './lib/expediente/models/evk-expediente.model';
export * from './lib/expediente/models/evk-expediente-config.model';
export * from './lib/expediente/models/evk-seccion.model';
export * from './lib/expediente/models/evk-seccion-config.model';

export * from './lib/expediente/services/expediente-create.service';
export * from './lib/expediente/services/expediente-update.service';
export * from './lib/expediente/services/expedientes-page.service';
export * from './lib/expediente/enums/tipo-expediente-enum';

export * from './lib/diligencia/diligencia.module';
export * from './lib/diligencia/components/tarea-documento-page/tarea-documento-page.component';
export * from './lib/diligencia/components/tarea-documento-create/tarea-documento-create.component';
export * from './lib/diligencia/components/evk-diligencia-respuesta/evk-diligencia-respuesta.component';
export * from './lib/diligencia/models/clasificacion-diligencia.model';
export * from './lib/diligencia/models/diligencia-tarea.model';
export * from './lib/diligencia/models/estado-document.model';
export * from './lib/diligencia/models/estado-tarea-document.model';
export * from './lib/diligencia/models/expediente-diligencia.model';
export * from './lib/diligencia/models/firma-electronica.model';
export * from './lib/diligencia/models/firma.model';
export * from './lib/diligencia/models/image-data.model';
export * from './lib/diligencia/models/respuesta-document.model';
export * from './lib/diligencia/models/tarea-documento.model';

export * from './lib/firma/firma.module';
export * from './lib/firma/componentes/firma-electronica/evk-firma-electronica/evk-firma-electronica.component';
export * from './lib/firma/componentes/firma-electronica/evk-firma-electronica-dialog/evk-firma-electronica-dialog.component';
export * from './lib/firma/componentes/firma-digital/evk-firma-digital/evk-firma-digital.component';
export * from './lib/firma/componentes/firma-digital/evk-firma-digital-dialog/evk-firma-digital-dialog.component';
export * from './lib/firma/models/evk-firma-digital.model';
export * from './lib/firma/models/evk-firma.model';
export * from './lib/firma/models/evk-firma-resultado.model';
export * from './lib/firma/services/firma-electronica.service';
export * from './lib/firma/componentes/config/ocsp-config';
export * from './lib/wizard/componentes/section/sub-components/cargar-requerimiento/cargar-requerimiento.component';
